import {z} from 'zod';

export const spaceConnectionCount = z.object({
    connected: z.number(),
    total: z.number(),
});

export type SpaceConnectionCount = z.infer<typeof spaceConnectionCount>;

export const adminRoomWithConnections = z.object({
    id: z.string(),
    name: z.string(),
    connectionCount: spaceConnectionCount,
});

export type AdminRoomWithConnections = z.infer<typeof adminRoomWithConnections>;

export const adminFloorWithConnections = adminRoomWithConnections.extend({
    rooms: z.array(adminRoomWithConnections),
});

export type AdminFloorWithConnections = z.infer<typeof adminFloorWithConnections>;

export const adminLocationWithConnections = adminRoomWithConnections.extend({
    floors: z.array(adminFloorWithConnections),
});

export type AdminLocationWithConnections = z.infer<typeof adminLocationWithConnections>;
